import React from "react";
import { Caption1 } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { FormatSmartAbsoluteDate } from "~/components/Formatters/FormatSmartAbsoluteDate";
import { dateToMySQLFormat } from "~/utils/date";
import { GroupHeaderTotal } from "./GroupHeaderTotal";

export const GroupHeader = ({ date, total, className, hideDivider, ...rest }) => {
  return (
    <div className={classNames("tw-flex", className)}>
      <Caption1 weight="bold">
        <FormatSmartAbsoluteDate date={dateToMySQLFormat(date)} />
      </Caption1>
      <div className="tw-flex">
        {!hideDivider ? (
          <Caption1
            color="secondary"
            weight="medium"
            className="tw-mx-1"
          >
            /
          </Caption1>
        ) : null}
        <GroupHeaderTotal
          total={total}
          {...rest}
        />
      </div>
    </div>
  );
};

GroupHeader.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  total: PropTypes.number.isRequired,
  className: PropTypes.string,
  hideDivider: PropTypes.bool,
};
